import classNames from "classnames";
import { useContext, useEffect, useState } from "react";
import NotificationDispatch, {
  hideNotification,
} from "../../context/notificationContext";
import SVGClose from "../../icons/Close.svg?react";
import SVGError from "../../icons/Error.svg?react";
import SVGInfo from "../../icons/Info.svg?react";
import SVGTaskAlt from "../../icons/TaskAlt.svg?react";
import Icon from "./Icon";
import styles from "./Notification.module.css";

interface Props {
  type: "success" | "error" | "informative";
  text: string;
  delayed?: number;
}

const Notification = ({ type, text, delayed = 3000 }: Props) => {
  const [mounted, setMounted] = useState(false);
  const [close, setClose] = useState(false);
  const dispatch = useContext(NotificationDispatch);

  useEffect(() => {
    const timeout = setTimeout(() => setMounted(true), 0);
    return () => clearTimeout(timeout);
  });

  useEffect(() => {
    const timeout = setTimeout(() => setClose(true), delayed);
    return () => clearTimeout(timeout);
  });

  return (
    <div
      className={classNames(styles.notification, {
        [styles.success]: type === "success",
        [styles.error]: type === "error",
        [styles.informative]: type === "informative",
        [styles.shown]: mounted,
        [styles.hidden]: close,
      })}
      onTransitionEnd={() => {
        if (close) dispatch(hideNotification());
      }}
    >
      <Icon
        className={styles.icon}
        glyph={
          { error: SVGError, success: SVGTaskAlt, informative: SVGInfo }[type]
        }
      />
      <div className={styles.text}>{text}</div>
      <button className={styles.closeButton} onClick={() => setClose(true)}>
        <Icon className={styles.closeIcon} glyph={SVGClose} />
      </button>
    </div>
  );
};

export default Notification;
